import React from 'react';
import '../styles/theme.css';
import '../styles/NewTestRun.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import NewTestRunMasthead from '../components/NewTestRunMasthead';
import NewTestRunConfigPanel from '../components/NewTestRunConfigPanel';
/* IMPORTS */

function NewTestRunPage() {
  return (
    <div className="ne-root">
      <div className="ne-layout-1">
        <div id="newtestrunheaderslot" className="ne-slot-newtestrunheaderslot">
          <BruteHeader activePage={"New Test Run"} />
        </div>
        <div className="ne-layout-2">
          <div id="newtestrunmasthead" className="ne-slot-newtestrunmasthead">
            <NewTestRunMasthead />
          </div>
          <div id="newtestrunconfigpanel" className="ne-slot-newtestrunconfigpanel">
            <NewTestRunConfigPanel />
          </div>
        </div>
        <div id="newtestrunfooterslot" className="ne-slot-newtestrunfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default NewTestRunPage;